// extracted by mini-css-extract-plugin
export default {"DangerText":"styles_DangerText__csxc4","dangerText":"styles_dangerText__XMb03"};